export default __webpack_public_path__ + "static/media/pacifica.230a1860.png";